import apiClient from './apiClient';

export const deleteClientFormat = async (id) => {
  try {
    const response = await apiClient.delete(`/client-format/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const downloadClientFormat = async (id) => {
  try {
    const response = await apiClient.get(`/client-format/${id}`, {
      responseType: 'blob'
    });
    return response;
  } catch (error) {
    throw error;
  }
};
